<template>
	<div>
		<VueSlickCarousel
			:arrows="false"
			:dots="true"
			:slidesToScroll="1"
			:slidesToShow="3"
			:responsive="[
				{
					breakpoint: 1720,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 1400,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1
					}
				}
			]"
			class="mt-3"
		>
			<div class="p-2">
				<div class="item">
					<div class="stars"></div>
					<p>
						Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
						labore et dolore magna aliqua.
					</p>
					<div class="author-content">
						<figure class="testimonial-img">
							<img src="https://api.lorem.space/image/face?w=150&h=150" alt="" />
						</figure>
						<div class="author-name">
							<h5>Roberto Lopez</h5>
							<span>MOTORHOME</span>
						</div>
					</div>
					<div class="testimonial-icon">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							class="icon icon-tabler icon-tabler-quote"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							stroke-width="2"
							stroke="currentColor"
							fill="none"
							stroke-linecap="round"
							stroke-linejoin="round"
						>
							<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
							<path
								d="M10 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5"
							></path>
							<path
								d="M19 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5"
							></path>
						</svg>
					</div>
				</div>
			</div>
			<div class="p-2">
				<div class="item">
					<div class="stars"></div>
					<p>
						Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
						labore et dolore magna aliqua.
					</p>
					<div class="author-content">
						<figure class="testimonial-img">
							<img src="https://api.lorem.space/image/face?w=150&h=150" alt="" />
						</figure>
						<div class="author-name">
							<h5>Roberto Lopez</h5>
							<span>MOTORHOME</span>
						</div>
					</div>
					<div class="testimonial-icon">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							class="icon icon-tabler icon-tabler-quote"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							stroke-width="2"
							stroke="currentColor"
							fill="none"
							stroke-linecap="round"
							stroke-linejoin="round"
						>
							<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
							<path
								d="M10 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5"
							></path>
							<path
								d="M19 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5"
							></path>
						</svg>
					</div>
				</div>
			</div>
			<div class="p-2">
				<div class="item">
					<div class="stars"></div>
					<p>
						Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
						labore et dolore magna aliqua.
					</p>
					<div class="author-content">
						<figure class="testimonial-img">
							<img src="https://api.lorem.space/image/face?w=150&h=150" alt="" />
						</figure>
						<div class="author-name">
							<h5>Roberto Lopez</h5>
							<span>MOTORHOME</span>
						</div>
					</div>
					<div class="testimonial-icon">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							class="icon icon-tabler icon-tabler-quote"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							stroke-width="2"
							stroke="currentColor"
							fill="none"
							stroke-linecap="round"
							stroke-linejoin="round"
						>
							<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
							<path
								d="M10 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5"
							></path>
							<path
								d="M19 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5"
							></path>
						</svg>
					</div>
				</div>
			</div>
		</VueSlickCarousel>
	</div>
</template>

<script>
import gql from "graphql-tag"

export default {
	data() {
		return {
			items: []
		}
	},
	beforeMount() {
		// this.load()
	},
	methods: {
		load() {
			return this.$apollo
				.query({
					query: gql`
						query($featured: Boolean) {
							pages(featured: $featured) {
								data {
									id
									title
									intro
									hasBody
									slug
									link
									image {
										id
										type
										filename
										url
										urlThumb
									}
								}
							}
						}
					`,
					variables: { featured: true },
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.items = data.pages.data
				})
				.catch(() => {})
		}
	}
}
</script>

<style scoped lang="scss">
.item {
	border-radius: 25px;
	box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
	padding: 30px;

	position: relative;

	.author-content {
		display: flex;
		flex-wrap: wrap;
		align-items: center;

		.testimonial-img {
			border-radius: 100%;
			overflow: hidden;
			width: 70px;
			height: 70px;
			img {
				width: 100%;
				height: 100%;
			}
		}
		.author-name {
			padding-left: 20px;
			h5 {
				text-transform: uppercase;
				margin-bottom: 5px;
				font-size: 16px;
				line-height: 1.1;
			}
			span {
				color: #3a78c9;
				font-size: 13px;
				text-transform: uppercase;
				line-height: 1;
				display: block;
			}
		}
	}
	.testimonial-icon {
		position: absolute;
		right: 20px;
		bottom: 20px;
		transform: rotate(180deg);

		svg {
			width: 48px;
			height: 48px;
			color: #f3f3f3;
		}
	}
}
</style>
